<template>
  <div class="banner_container">
    <div v-if="this.closed && imageLoaded" class="banner__closed"></div>
    <div v-if="this.closed && imageLoaded" class="banner__text">{{ $t('eventClosed') }}</div>
    <banner-countdown
      :beginAt="beginAt"
      :endAt="endAt"
      :baseColor="countdownBackgroundBaseColor"
      :fontColor="bannerFontColor"
    ></banner-countdown>
    <img 
      class="banner__img" 
      :src="url" 
      alt="" 
      @error="onImageError"
    />

    <span v-if="isUserScoring" class="scoring-label">
      <img class="scoring-icon" src="/img/icon-thunder.svg" />
      {{ $t('isScoringEvent') }}
    </span>
  </div>
</template>

<script>
import BannerCountdown from '@/components/BannerCountdown.vue'
export default {
  name: 'banner',
  components: {
    BannerCountdown,
  },
  props: {
    url: String,
    closed: Boolean,
    beginAt: Date,
    endAt: Date,
    countdownBackgroundBaseColor: String,
    isUserScoring: Boolean,
    hasEntered: Boolean,
    bannerFontColor: String,
  },
  data() {
    return {
      imageLoaded: true,
    }
  },
  computed: {
    isDoing() {
      if (!this.beginAt || !this.endAt) {
        return false
      }
      const now = Date.now()
      return this.beginAt.getTime() <= now && now < this.endAt.getTime()
    },
  },
  methods: {
    onImageError() {
      this.imageLoaded = false
    },
  },
}
</script>

<style scoped>
.banner_container {
  position: relative;
  text-align: center;
}

.banner__img {
  max-width: 500px;
  max-height: 422px;
  width: 100%;
  height: auto;
  background-color: #f8f8f8;
  vertical-align: bottom;
}

.scoring-label {
  position: absolute;
  z-index: 1;
  bottom: 10px;
  right: 10px;
  background: linear-gradient(to left, #ff003d, #ff788c);
  padding: 2px 8px 2px 5px;
  color: white;
  font-weight: bold;
  font-size: 12px;
  border-radius: 4px;
}

.scoring-icon {
  position: relative;
  height: 14px;
  margin-left: 1px;
  margin-bottom: 2.5px;
}

.banner__closed {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
}

.banner__text {
  color: white;
  font-size: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
</style>
